import React from 'react';

import CurrentVersionReadOnlyReasonWrapper from 'app/developer-v3/components/CurrentVersionReadOnlyReasonWrapper';

import ActionGroupInputEditor from './ActionGroupInputEditor';

export default function ActionGroupInputEditorWrapper(props) {
  return (
    <CurrentVersionReadOnlyReasonWrapper
      Component={ActionGroupInputEditor}
      {...props}
    />
  );
}
